import chromePngUrl from "../../../assets/chrome.png";
import ClarotyXdomeLogo from "@claroty/xdome-design-system/components/Logos/ClarotyXdomeLogo";
import ExternalLink from "../Link/ExternalLink";
import browserErrorSvgUrl from "../../../assets/browserError.svg";
import edgeSvgUrl from "../../../assets/edge.svg";
import firefoxSvgUrl from "../../../assets/firefox.svg";
import "./BrowserNotSupported.scss";

type BrowserNotSupportedProps = {
    message: string;
};

const BrowserNotSupported = ({ message }: BrowserNotSupportedProps) => {
    return (
        <div className="browser-not-supported-container">
            <div className="browser-nav-bar">
                <ClarotyXdomeLogo />
            </div>
            <div className="browser-not-supported-content-container">
                <img src={browserErrorSvgUrl} className="browser-not-supported-img" />
                <div className="browser-not-supported-text-container">{message}</div>
                <div className="browsers-container">
                    <ExternalLink to="https://www.google.com/chrome/">
                        <img src={chromePngUrl} className="browser-img" />
                    </ExternalLink>
                    <ExternalLink to="https://www.mozilla.org/en-US/firefox/">
                        <img src={firefoxSvgUrl} className="browser-img" />
                    </ExternalLink>
                    <ExternalLink to="https://www.microsoft.com/en-us/edge/">
                        <img src={edgeSvgUrl} className="browser-img" />
                    </ExternalLink>
                </div>
            </div>
        </div>
    );
};

export default BrowserNotSupported;
